import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import PaymentEditor from './PaymentEditor';

function QuickPayment() {
	const navigate = useNavigate();
	const returnTo = '/AdminScreen';

	return (
		<EntityList>
			<Helmet>
				<title>Cargar Pago</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Cobros', to: '/AdminScreen/payments' },
					{ label: 'Cargar Pago' },
				]}
				title='Cargar Pago'
				subtitle='Completá los datos para registrar el cobro.'
			/>
			<PaymentEditor
				mode='create'
				entityFilter
				onCancel={() => navigate(returnTo)}
				onSaved={() => navigate(returnTo)}
				saveLabel='Agregar'
			/>
		</EntityList>
	);
}

export default QuickPayment;
